import ajax from '@/utils/ajax';

const head = '/web';
// 获取用户前台定金单列表
export const reqDepositList = () => ajax(`${head}/v1/deposit-order/list/front`);

// 用户端我的定金单详情

export const reqDepositDetail = (depositOrderNo) => ajax(`${head}/v1/deposit-order/detail?depositOrderNo=${depositOrderNo}`);

// 取消定金单
export const reqCancelDeposit = (depositOrderNo) => ajax(`${head}/v1/deposit-order/cancel-deposit/${depositOrderNo}`);
